"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDPSExplorerIntegrationFeature = IDPSExplorerIntegrationFeature;
const idps_consensus_1 = require("@branch-ts/idps-consensus");
const practice_idps_web_1 = require("@branch-ts/practice-idps-web");
const practice_verse_web_1 = require("@branch-ts/practice-verse-web");
const web_1 = require("@branch-ts/web");
const web_consensus_1 = require("@branch-ts/web-consensus");
function IDPSExplorerIntegrationFeature(config) {
    const makeIdpExplorer = (uri) => {
        const isSupported = !!(idps_consensus_1.IDPSProtocol.IDPScopeURI.parse(uri)
            || idps_consensus_1.IDPSProtocol.BlockURI.parse(uri)
            || idps_consensus_1.IDPSProtocol.ThreadURI.parse(uri)
            || idps_consensus_1.IDPSProtocol.Signal.NewIdps.parse(uri));
        if (!isSupported) {
            return null;
        }
        const explorer = config.createExplorer();
        void explorer.present.configure({
            uri,
            candidates: config.makeDutyCandidates(),
        });
        return explorer;
    };
    web_consensus_1.PuriAppMechanism.register({
        name: "VersetIdpExplorer",
        registry: (option) => makeIdpExplorer(option.uri),
    });
    practice_verse_web_1.PopupAppSupportRegistryMechanism.register({
        name: "VersetIdpExplorer",
        registry: (option) => makeIdpExplorer(option.uri),
    });
    for (const editorKind of new Set(config.editorKinds)) {
        (0, practice_idps_web_1.IdpsRuneFeature)({ editorKind });
    }
    web_1.NavigationService.global.addNavigation({
        name: "IdpExplorer",
        path: "/idps",
        view: () => {
            return configureRoutedExplorer(config);
        },
    }).addNavigation({
        name: "IdpExplorerStandalone",
        path: "/idps/standalone",
        view: () => {
            return configureRoutedExplorer(config);
        },
        isFullscreen: true,
    });
}
function configureRoutedExplorer(config) {
    const explorer = config.createExplorer();
    explorer.present.route(async (option) => {
        const uri = option.params.uri || idps_consensus_1.IDPSProtocol.Signal.NewIdps.make({
            spaceURI: config.scopeSpaceURI,
        });
        const candidates = config.makeDutyCandidates();
        const duty = candidates.find(item => item.name === option.params.duty) || undefined;
        return {
            uri,
            duty,
            candidates,
        };
    });
    return explorer;
}
